export type CardVariant = 'inset' | 'elevated';

export interface FeatureCard {
  title: string;
  description: string;
  variant: CardVariant;
}

export const cards: FeatureCard[] = [
  {
    title: 'whatWeDo.task1.title',
    description: 'whatWeDo.task1.description',
    variant: 'inset',
  },
  {
    title: 'whatWeDo.task2.title',
    description: 'whatWeDo.task2.description',
    variant: 'elevated',
  },
  {
    title: 'whatWeDo.task3.title',
    description: 'whatWeDo.task3.description',
    variant: 'elevated',
  },
  {
    title: 'whatWeDo.task4.title',
    description: 'whatWeDo.task4.description',
    variant: 'inset',
  },
];
